import React from 'react'

import { RightSidebarCardAttribute } from 'components/ContactSidebar/SFDCCard'

export const SalesforceContext = React.createContext<RightSidebarCardAttribute[]>([])
